// src/pages/patientInfo/FAQ.jsx

import React from "react";
import "./FAQ.css";

function FAQ() {
  return (
    <div className="faq-container">
      <h1 className="faq-main-title">Frequently Asked Questions</h1>

      {/* Card: About Treatment */}
      <section className="faq-card">
        <h2 className="faq-category">About Treatment</h2>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            How long does each physiotherapy session last?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            Each session typically lasts 45-60 minutes, depending on your condition and treatment plan.
          </div>
        </div>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            How many sessions will I need?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            The number of sessions varies based on your condition, recovery goals, and progress. Your physiotherapist will provide a recommended treatment timeline after your initial assessment.
          </div>
        </div>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            Do I need a doctor's referral to see a physiotherapist?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            No, you can book an appointment directly. However, if you have a referral, please bring it along with any relevant medical reports.
          </div>
        </div>
      </section>

      {/* Card: Treatment Process */}
      <section className="faq-card">
        <h2 className="faq-category">Treatment Process</h2>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            What should I wear to my physiotherapy session?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            Wear comfortable, loose-fitting clothes that allow easy movement and access
            to the area requiring treatment. For lower body treatment, shorts are recommended.
          </div>
        </div>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            Will my treatment be painful?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            While some techniques may cause temporary discomfort, your physiotherapist
            will work within your comfort levels and adjust techniques based on your feedback.
          </div>
        </div>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            Can I bring someone with me to my sessions?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            Yes, you’re welcome to bring a family member or friend to your sessions.
          </div>
        </div>
      </section>

      {/* Card: Home Visits */}
      <section className="faq-card alt-bg">
        <h2 className="faq-category">Home Visits</h2>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            What areas do you cover for home visits?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            We currently serve Haldibari and surrounding areas within a 25 km radius, including Jalpaiguri
          </div>
        </div>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            Is there an additional charge for home visits?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            Yes, home visits include a travel fee. Please contact us for specific pricing details.
          </div>
        </div>
      </section>

      {/* Card: Appointments */}
      <section className="faq-card">
        <h2 className="faq-category">Appointments</h2>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            How do I schedule an appointment?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            You can book appointments through our website, by phone, or email. [Include contact details]
          </div>
        </div>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            What is your cancellation policy?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            We request 24 hours notice for cancellations. Late cancellations or no-shows may incur a fee.
          </div>
        </div>
      </section>

      {/* Card: Treatment Results */}
      <section className="faq-card alt-bg">
        <h2 className="faq-category">Treatment Results</h2>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            How soon will I see results?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            Results vary by individual and condition. Some patients feel improvement after their first session, while others may take several sessions to notice significant changes.
          </div>
        </div>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            Will I need to do exercises at home?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            Yes, home exercises are a crucial part of your recovery. Your physiotherapist will provide specific exercises tailored to your condition.
          </div>
        </div>
      </section>

      {/* Card: About Our Services */}
      <section className="faq-card">
        <h2 className="faq-category">About Our Services</h2>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            What conditions do you treat?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            We treat a wide range of conditions including orthopedic conditions, sports injuries, post-surgical rehab, neurological conditions, back & neck pain, and more.
          </div>
        </div>

        <div className="faq-qa">
          <div className="faq-question">
            <span className="faq-q-icon">Q:</span>
            Do you provide any documentation of my progress?
          </div>
          <div className="faq-answer">
            <span className="faq-a-icon">A:</span>
            Yes, we maintain detailed records of your progress and can provide reports for your referring healthcare provider.
          </div>
        </div>
      </section>

    </div>
  );
}

export default FAQ;
